// tables/MoveOrderTable.tsx
import React from 'react';
import { Card } from '@components/card/card';

interface MoveOrderTableProps {
  data: any[];
  selectedId: string | null;
  onSelect: (id: string, code: string) => void;
  isLoading: boolean;
  language: string;
}

export const MoveOrderTable: React.FC<MoveOrderTableProps> = ({ data, selectedId, onSelect, isLoading, language }) => {
  const isArabic = language === 'ar';

  const getTotalAmount = () => {
    return data.reduce((sum, item) => sum + (item.transactionAmount || 0), 0);
  };

  const getSelectedAmount = () => {
    const selectedItem = data.find(item => item.id === selectedId);
    return selectedItem ? selectedItem.transactionAmount || 0 : 0;
  };

  if (isLoading) {
    return (
      <div className='text-center py-5'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>جاري التحميل...</span>
        </div>
        <p className='text-muted mt-2'>جاري تحميل أوامر التحويل...</p>
      </div>
    );
  }

  return (
    <Card className='mb-4'>
      <div className='card-header d-flex justify-content-between align-items-center'>
        <h6 className='mb-0'>
          <i className='fas fa-exchange-alt me-2'></i>
          قائمة أوامر التحويل
        </h6>
        <div></div>
      </div>

      <div className='card-body p-0'>
        <div className='table-responsive' style={{ maxHeight: '300px', overflowY: 'auto' }}>
          <table className='table table-hover mb-0'>
            <thead className='fw-bold' style={{ position: 'sticky', top: 0, zIndex: 1, backdropFilter: 'blur(20px)' }}>
              {/* <thead className='bg-theme bg-opacity-25  fw-bold'> */}
              <tr>
                <th className=' small'>#</th>
                <th className='text-center small'>رقم أمر التحويــل</th>
                <th className='text-center small'>تاريخ أمر التحويـل</th>
                <th className=' small'>الى</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                const isSelected = selectedId === item.id;

                return (
                  <tr
                    key={item.id}
                    className={isSelected ? 'table-primary' : ''}
                    style={{ cursor: 'pointer' }}
                    onClick={() => onSelect(item.id, item.code)}
                  >
                    <td className='text-center align-middle'>
                      <div className='form-check'>
                        <input
                          type='radio'
                          className='form-check-input'
                          name='moveOrderSelection'
                          checked={isSelected}
                          onChange={() => onSelect(item.id, item.code)}
                        />
                      </div>
                    </td>

                    <td className='text-center align-middle fw-bold'>{item.code}</td>

                    <td className='text-center align-middle'>{item.transactionDate?.split('T')[0]}</td>
                    <td className='text-center align-middle'>
                      <div className='d-flex flex-column '>
                        <small className='d-flex align-items-center'>
                          <i className='fas fa-building me-1'></i> وحدة التشغيل:{' '}
                          {(isArabic ? item.branchToName2 : item.branchToName) || '—'}
                        </small>

                        <small className='d-flex align-items-center'>
                          <i className='fas fa-warehouse me-1'></i> المخزن:{' '}
                          {(isArabic ? item.inventoryToName2 : item.inventoryToName) || '—'}
                        </small>
                      </div>
                    </td>

                    {/* <td className='text-center align-middle'>
                      <div className='d-flex flex-column'>
                        <small className={`text-muted `}>
                          <i className='fas fa-random me-1'></i> {'وحدة التشغيل'}:{' '}
                          {(isArabic ? item.branchToName2 : item.branchToName) || '—'}
                        </small>

                        <small className={`text-muted `}>
                          <i className='fas fa-random me-1'></i> {'المخزن'}:{' '}
                          {isArabic ? item.inventoryToName2 : item.inventoryToName || '—'}
                        </small>
                      </div>
                    </td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className='card-footer d-flex justify-content-between align-items-center'>
        <div className='text-muted small'>
          عرض {data.length} من {data.length} أمر تحويل
        </div>
        <div className='text-theme fw-bold'>
          {selectedId ? `المبلغ المحدد: ${getSelectedAmount().toLocaleString()} ر.س` : 'يرجى اختيار أمر تحويل'}
        </div>
      </div>
    </Card>
  );
};
